"use strict";

class SilentLogin {
  constructor() {
    this.instance = null;
    window.addEventListener("message", this.silentLoginHandler);
  }

  silentLoginHandler = (e) => {
    if (this.instance && e.data && e.data.source === 'bff-silent-login' && e.data.isLoggedIn) {
      document.querySelector('#bff-silent-login').src = null;
      let _ = this.instance.invokeMethod("SilentLoginSuccess", e);
    }
  };

  initializeSilentLogin = (instance) => {
    this.instance = instance;
    document.querySelector('#bff-silent-login').src = '/bff/silent-login';
  };

}

const silentLogin = new SilentLogin();

window.SilentLogin = silentLogin;

if (typeof globalThis === "object")
  globalThis.SilentLogin = silentLogin;
